export const GET_BIKE_REQUEST="GET_BIKE_REQUEST";
export const GET_BIKE_SUCCESS="GET_BIKE_SUCCSS";
export const GET_BIKE_FAILURE="GET_BIKE_FAILURE";